import Vue from 'vue';
import axios from 'axios';
import configApi from '../config';
import VueLocalStorage from 'vue-localstorage';
import store from '@/store';
import NotificationService from '@/services/NotificationService';

const axiosOptions = {
  baseURL: configApi.API_LOCATION,
  timeout: 10000000,
  withCredentials: true,
};

Vue.use(VueLocalStorage);

export default function httpClient() {
  const userToken = store.getters.getToken;
  const api = axios.create(axiosOptions);

  if (userToken && userToken.token) {
    api.defaults.headers.common.Authorization = 'Bearer '.concat(
      userToken.token
    );
    api.defaults.headers.common['Content-Type'] = 'application/json';
  }
  return api;
}

export function httpClientWithCancel() {
  const userToken = store.getters.getToken;
  const api = axios.create(axiosOptions);

  if (userToken && userToken.token) {
    api.defaults.headers.common.Authorization = 'Bearer '.concat(
      userToken.token
    );
    api.defaults.headers.common['Content-Type'] = 'application/json';
  }

  api.interceptors.request.use(
    (request) => {
      return request;
    },
    (err) => {
      NotificationService.errorRequest(err);
    }
  );

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (err) => {
      if (axios.isCancel(err)) return;
      NotificationService.errorRequest(err);
    }
  );

  return api;
}
